import { config, authHeader, handleResponse } from '../helpers';

export const mentorService = {
    getMentorTeamData
};

function getMentorTeamData() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.baseUrl}/mentor/team-details`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        });
}
